import { DocumentItem } from "../hooks/useDocumentManagement";

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return Math.round((bytes / Math.pow(k, i)) * 10) / 10 + " " + sizes[i];
};

export const formatDate = (date: Date): string => {
  return date.toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
};

export const createNewDocument = (file: File): DocumentItem => ({
  id: crypto.randomUUID(),
  file,
  description: "",
  note: "",
  uploadedAt: new Date(),
  isUploading: true
});

export const isDocumentUploading = (doc: DocumentItem): boolean =>
  doc.isUploading === true;

export const isDocumentUploaded = (doc: DocumentItem): boolean =>
  !!doc.uploadedResponse && !doc.isUploading;

export const hasDocumentError = (doc: DocumentItem): boolean =>
  !!doc.uploadError && !doc.isUploading;
